// import styles from "./BallroomHero.module.css";
// import { Link } from "react-router-dom";

// export default function BallroomHero({ hotel, ballroom }) {
//   if (!hotel || !ballroom) return null;

//   const heroImage =
//     ballroom.images?.[0]?.image ||
//     hotel.featured_image ||
//     "/images/placeholder-ballroom.jpg";

//   const maxCapacity =
//     ballroom.capacities?.length > 0
//       ? Math.max(...ballroom.capacities.map((c) => c.capacity))
//       : null;

//   return (
//     <section className={styles.hero}>
//       <div className={styles.container}>
//         {/* Left Content */}
//         <div className={styles.content}>
//           <p className={styles.hotelName}>
//             {hotel.name} • {hotel.city}, {hotel.state}
//           </p>

//           <h1 className={styles.title}>{ballroom.name}</h1>

//           <div className={styles.quickFacts}>
 
//             {maxCapacity && (
//               <div className={styles.fact}>
//                 <span className={styles.label}>Capacity</span>
//                 <span>{maxCapacity} Guests</span>
//               </div>
//             )}
    

//             {ballroom.carpet_area && (
//               <div className={styles.fact}>
//                 <span className={styles.label}>Area</span>
//                 <span>{ballroom.carpet_area} sq ft</span>
//               </div>
//             )}

//             {ballroom.ceiling_height && (
//               <div className={styles.fact}>
//                 <span className={styles.label}>Ceiling</span>
//                 <span>{ballroom.ceiling_height} ft</span>
//               </div>
//             )}
//           </div>

//           <div className={styles.actions}>
//             <Link
//               to={`/venue-planner/hotel/${hotel.slug}`}
//               className={styles.secondaryBtn}
//             >
//               ← View Hotel
//             </Link>

//             <a
//               href="#capacity"
//               className={styles.primaryBtn}
//             >
//               View Capacity
//             </a>
//           </div>
//         </div>

//         {/* Right Image */}
//         <div className={styles.imageWrapper}>
//           <img
//             src={heroImage}
//             alt={`${ballroom.name} at ${hotel.name}`}
//             className={styles.image}
//             loading="eager"
//           />
//         </div>
//       </div>
//     </section>
//   );
// }


import styles from "./BallroomHero.module.css";
import { Link } from "react-router-dom";

export default function BallroomHero({ hotel, ballroom }) {
  if (!hotel || !ballroom) return null;

  const heroImage =
    ballroom.images?.[0]?.image ||
    hotel.featured_image ||
    "/images/placeholder-ballroom.jpg";

  const maxCapacity =
    ballroom.capacities?.length > 0
      ? Math.max(...ballroom.capacities.map((c) => c.capacity))
      : null;

  // Format dimensions
  const dimensions = ballroom.dimensions
    ? /\bft\b/i.test(ballroom.dimensions)
      ? ballroom.dimensions
      : `${ballroom.dimensions} ft`
    : ballroom.length && ballroom.width
      ? `${ballroom.length} × ${ballroom.width}${
          ballroom.height ? ` × ${ballroom.height}` : ""
        } ft`
      : null;

  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        {/* Left Content */}
        <div className={styles.content}>
          <p className={styles.hotelName}>
            {hotel.name} • {hotel.city}, {hotel.state}
          </p>

          <h1 className={styles.title}>{ballroom.name}</h1>

          <div className={styles.quickFacts}>

            {maxCapacity && (
              <div className={styles.fact}>
                <span className={styles.label}>Capacity</span>
                <span>{maxCapacity} Guests</span>
              </div>
            )}

            {/* Dimensions */}
            {dimensions && (
              <div className={styles.fact}>
                <span className={styles.label}>Dimensions</span>
                <span>{dimensions}</span>
              </div>
            )}

            {ballroom.carpet_area && (
              <div className={styles.fact}>
                <span className={styles.label}>Area</span>
                <span>{ballroom.carpet_area} sq ft</span>
              </div>
            )}

            {ballroom.ceiling_height && (
              <div className={styles.fact}>
                <span className={styles.label}>Ceiling</span>
                <span>{ballroom.ceiling_height} ft</span>
              </div>
            )}
          </div>

          <div className={styles.actions}>
            <Link
              to={`/venue-planner/hotel/${hotel.slug}`}
              className={styles.secondaryBtn}
            >
              ← View Hotel
            </Link>

            <a href="#capacity" className={styles.primaryBtn}>
              View Capacity
            </a>
          </div>
        </div>

        {/* Right Image */}
        <div className={styles.imageWrapper}>
          <img
            src={heroImage}
            alt={`${ballroom.name} at ${hotel.name}`}
            className={styles.image}
            loading="eager"
          />
        </div>
      </div>
    </section>
  );
}
